import isString from 'lodash/isString';

export enum SideBarDrawerDirection {
	Left = 'left',
	Right = 'right',
}

export const isValidSideBarDrawerDirection = (direction: unknown): direction is SideBarDrawerDirection =>
	isString(direction) && Object.values(SideBarDrawerDirection).includes(direction as SideBarDrawerDirection);
